module.exports = "img/flags/OM.9bcb720.png";